module.exports = __webpack_public_path__ + "img/banner.3143a692.png";